import { formatMilliseconds } from '@app/utils/formaters.ts';
import Badge from 'react-bootstrap/Badge';
import { useMemo } from 'react';

const Timestamp = ({ ts }: { ts: number | undefined}) => {
  const timeStr = useMemo(() => (formatMilliseconds(ts)), [ts]);
  return (timeStr ? <Badge bg="secondary" className="mx-1">{timeStr}</Badge> : null);
};

export default Timestamp;
